// extracted by mini-css-extract-plugin
export default {"firstColumnCell":"TasksTable_firstColumnCell__dJL95","header":"TasksTable_header__bNUDt","cell__action":"TasksTable_cell__action__RmI8X"};